import { FaBuilding, FaExternalLinkAlt } from 'react-icons/fa'
import './CompaniesContacts.scss'

type EntityType = 'Kunde' | 'Holding' | 'Gesellschaft' | 'Objekt' | 'Lieferant'

type CompanyContact = {
  id: string
  name: string
  customerNumber: string | null
  type: EntityType
  updatedAt: string
}

const ENTITIES: CompanyContact[] = [
  {
    id: '1',
    name: 'Musterkunde GmbH',
    customerNumber: 'C-10023',
    type: 'Kunde',
    updatedAt: '08.05.2024',
  },
  {
    id: '2',
    name: 'Musterkunde Holding GmbH',
    customerNumber: null,
    type: 'Holding',
    updatedAt: '12.03.2024',
  },
  {
    id: '3',
    name: 'Muster Energie GmbH',
    customerNumber: null,
    type: 'Gesellschaft',
    updatedAt: '12.03.2024',
  },
  {
    id: '4',
    name: 'Muster Services GmbH',
    customerNumber: null,
    type: 'Gesellschaft',
    updatedAt: '12.03.2024',
  },
  {
    id: '5',
    name: 'Wohnanlage Parkblick',
    customerNumber: null,
    type: 'Objekt',
    updatedAt: '12.03.2024',
  },
  {
    id: '6',
    name: 'Haus A',
    customerNumber: null,
    type: 'Objekt',
    updatedAt: '12.03.2024',
  },
  {
    id: '7',
    name: 'Haus B',
    customerNumber: null,
    type: 'Objekt',
    updatedAt: '12.03.2024',
  },
  {
    id: '8',
    name: 'Tiefgarage',
    customerNumber: null,
    type: 'Objekt',
    updatedAt: '12.03.2024',
  },
  {
    id: '9',
    name: 'Bau & Co. KG',
    customerNumber: null,
    type: 'Lieferant',
    updatedAt: '12.03.2024',
  },
]

function CompaniesContacts() {
  return (
    <section className="companies-contacts">
      <header className="companies-contacts__header">
        <h1 className="companies-contacts__title">
          <FaBuilding className="companies-contacts__title-icon" aria-hidden="true" />
          Firmen & Kontakte (Core)
        </h1>
        <p className="companies-contacts__subtitle">
          Diese Liste ist die Wahrheit im Core. Module wie CRM referenzieren diese
          Einheiten, duplizieren sie aber nicht.
        </p>
      </header>

      <div className="companies-contacts__table-wrapper">
        <table className="companies-contacts__table">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Kundennummer</th>
              <th scope="col">Art</th>
              <th scope="col">Aktualisiert</th>
              <th scope="col" className="companies-contacts__action-col">
                <span className="visually-hidden">Öffnen</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {ENTITIES.map((entity) => (
              <tr key={entity.id}>
                <td className="companies-contacts__name">{entity.name}</td>
                <td className="companies-contacts__customer-number">
                  {entity.customerNumber ?? <span className="companies-contacts__dash">—</span>}
                </td>
                <td>
                  <span
                    className={`companies-contacts__badge companies-contacts__badge--${entity.type.toLowerCase()}`}
                  >
                    {entity.type}
                  </span>
                </td>
                <td className="companies-contacts__updated">{entity.updatedAt}</td>
                <td className="companies-contacts__action-col">
                  <button
                    type="button"
                    className="companies-contacts__open"
                    aria-label={`${entity.name} öffnen`}
                  >
                    Öffnen
                    <FaExternalLinkAlt className="companies-contacts__open-icon" aria-hidden="true" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}

export default CompaniesContacts
